module.exports = __webpack_public_path__ + "public/images/overview/Kohanuk.344a730428d5124becd7fdfdc43e2532.png";